<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <div class="col-md-12">
          <label class="col-form-label control-label">{{
            $t('user.permission')
          }}</label>
          <div id="sub-group">
            <table class="table table-hover ui-table ts-table">
              <thead>
                <tr>
                  <th class="ts-sticky ts-top-0 ts-z-10">
                    <input
                      v-model="searchPermissionText"
                      type="text"
                      style="width:300px"
                      class="form-control"
                      :placeholder="$t('search')"
                    />
                  </th>
                  <th
                    v-for="column in permissionColumns"
                    :key="column"
                    class="ts-sticky ts-top-0 ts-z-10 ts-w-20 ts-text-center"
                  >
                    <div
                      class="ts-flex ts-flex-col ts-justify-center ts-items-center ts-w-full"
                    >
                      <p>{{ column }}</p>
                      <ts-checkbox
                        :checkedValue="allCheckedBy(column)"
                        @change="checked => selectAllBy(column, checked)"
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(group, groupName) in permissionGroups">
                  <tr>
                    <td>
                      <span
                        class="ts-text-sm ts-font-semibold ts-pt-6 ts-inline-block"
                        >{{ groupName }}</span
                      >
                    </td>
                    <td v-for="n in permissionColumns.length" :key="n">
                      <div class="ts-flex ts-justify-center ts-pt-6">
                        <ts-checkbox
                          :checkedValue="
                            allCheckedByGroup(
                              groupName,
                              permissionColumns[n - 1]
                            )
                          "
                          @change="
                            checked =>
                              selectByGroup(
                                groupName,
                                permissionColumns[n - 1],
                                checked
                              )
                          "
                        />
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-for="(permissions, resourceName) in group"
                    :key="resourceName"
                  >
                    <td>
                      <span class="ts-ml-4 ts-mr-6">{{ resourceName }}</span>
                    </td>
                    <td v-for="n in permissionColumns.length" :key="n">
                      <div class="ts-flex ts-justify-center">
                        <ts-checkbox
                          v-model="model.permissions"
                          :value="permissions[n - 1].id"
                          v-if="permissions[n - 1] !== undefined"
                        />
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {
  cloneDeep,
  union,
  uniq,
  difference,
  intersection,
  flatMap,
  map,
  filter
} from 'lodash'
export default {
  name: 'permissionComponent',
  props: ['value'],
  data() {
    return {
      loading: false,
      model: {}
    }
  },
  created() {
    this.fetchData()
    this.model = this.value
  },
  computed: {
    ...mapState('security/user', ['permissions']),
    ...mapGetters('security/user', ['permissionGroups', 'permissionColumns']),
    searchPermissionText: {
      get() {
        return this.$store.state.security.user.searchPermissionText
      },
      set(newValue) {
        this.$store.commit('security/user/SET_SEARCH_PERMISSION', newValue)
      }
    },
    idPermissionsBy: vm => column => {
      return uniq(
        map(
          filter(vm.permissions, p => {
            return p.name.toLowerCase().startsWith(column.toLowerCase())
          }),
          'id'
        )
      )
    },
    allCheckedBy: vm => column => {
      const idPermissions = vm.idPermissionsBy(column)
      return (
        intersection(vm.model.permissions, idPermissions).length ===
        idPermissions.length
      )
    },
    idPermissionsGroup: vm => (groupName, column) => {
      return uniq(
        map(
          filter(flatMap(vm.permissionGroups[groupName]), p => {
            return p.name.toLowerCase().startsWith(column.toLowerCase())
          }),
          'id'
        )
      )
    },
    allCheckedByGroup: vm => (groupName, column) => {
      const idPermissions = vm.idPermissionsGroup(groupName, column)
      return (
        intersection(vm.model.permissions, idPermissions).length ===
        idPermissions.length
      )
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('security/user/fetchPermissions')
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectAllBy(column, checked) {
      if (checked) {
        this.model.permissions = union(
          this.model.permissions,
          this.idPermissionsBy(column)
        )
      } else {
        this.model.permissions = difference(
          this.model.permissions,
          this.idPermissionsBy(column)
        )
      }
    },
    selectByGroup(groupName, column, checked) {
      if (checked) {
        this.model.permissions = union(
          this.model.permissions,
          this.idPermissionsGroup(groupName, column)
        )
      } else {
        this.model.permissions = difference(
          this.model.permissions,
          this.idPermissionsGroup(groupName, column)
        )
      }
    }
  }
}
</script>

<style lang="css" scoped>
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-color: #e2e7eb;
  padding: 4px 2px !important;
}
#sub-group {
  min-height: 30vh;
  max-height: 70vh;
  overflow-y: scroll;
}
</style>
